<template>
<div>
  <!-- Preloader Starts -->
  <div class="preloader">
    <div class="spinner"></div>
  </div>
  <!-- Preloader End -->
  <div class="merquee">
    <span class="merquee-txt">    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER</span>
    <span class="merquee-txt">    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER</span>
    <span class="merquee-txt">    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER</span>
  </div>

  <!-- Header Area Starts -->
  <div class="header-top" style="background: #fffaec;padding: 10px 0;">
    <div class="container">
      <div class="row">
        <el-col :span="12" :xs="20" style="display:flex;">
          <div class="logo-area">
            <router-link to="/">
              <img src="static/assets/images/logo-light.png" alt="logo" style="width: 80px;margin-top: 0">
            </router-link>
          </div>
          <div class="fontfamily" style="justify-content: center;align-self: center;font-weight: 600;margin-left: 20px">
            MOUNT GAMBIER BREWERY
          </div>
        </el-col>
        <el-col :span="12" :xs="4" style="justify-content: center;align-self: center;display:flex;">
          <div class="custom-navbar" style="margin-left: auto">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="main-menu main-menu-light">
            <ul style="top: 110px">
<!--              <li class="active"><router-link to="/" style="color: #000">shop</router-link></li>-->
              <li><router-link to="/about" style="color: #000" class="custom-navbarli">OPEN AND CLOSE</router-link></li>
              <li><router-link to="/category" style="color: #000" class="custom-navbarli">VENUE</router-link></li>
              <li><router-link to="/blogDetails" style="color: #000" class="custom-navbarli">MENU</router-link></li>
              <li><router-link to="/contact" style="color: #000" class="custom-navbarli">CONTACT</router-link></li>
            </ul>
          </div>
        </el-col>
      </div>
    </div>
  </div>
<!--  <header class="header-area single-page">-->
<!--    <div class="page-title text-center">-->
<!--      <div class="container">-->
<!--        <div class="row">-->
<!--          <div class="col-md-6 offset-md-3">-->
<!--            <h2>Comport</h2>-->
<!--            <p>There spirit beginning bearing the open at own every give appear in third you sawe two boys</p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </header>-->
  <!-- Header Area End -->

  <router-view></router-view>
  <div class="merquee">
    <span class="merquee-txt">    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER</span>
    <span class="merquee-txt">    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER</span>
    <span class="merquee-txt">    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★
          CRAFT BEER</span>
  </div>
  <!-- Footer Area Starts -->
<!--  <footer class="footer-area section-padding">-->
<!--    <div class="footer-widget">-->
<!--      <div class="container">-->
<!--        <div class="row">-->
<!--          <div class="col-xl-2 col-lg-3">-->
<!--            <div class="single-widget-home mb-5 mb-lg-0">-->
<!--              <h3 class="mb-4">top products</h3>-->
<!--              <ul>-->
<!--                <li class="mb-2"><a href="#">managed website</a></li>-->
<!--                <li class="mb-2"><a href="#">managed reputation</a></li>-->
<!--                <li class="mb-2"><a href="#">power tools</a></li>-->
<!--                <li><a href="#">marketing service</a></li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-xl-5 offset-xl-1 col-lg-6">-->
<!--            <div class="single-widget-home mb-5 mb-lg-0">-->
<!--              <h3 class="mb-4">newsletter</h3>-->
<!--              <p class="mb-4">You can trust us. we only send promo offers, not a single.</p>-->
<!--              <form action="#">-->
<!--                <input type="email" placeholder="Your email here" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Your email here'" required>-->
<!--                <button type="submit" class="template-btn">subscribe now</button>-->
<!--              </form>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-xl-3 offset-xl-1 col-lg-3">-->
<!--            <div class="single-widge-home">-->
<!--              <h3 class="mb-4">instagram feed</h3>-->
<!--              <div class="feed">-->
<!--                <img src="static/assets/images/feed1.jpg" alt="feed">-->
<!--                <img src="static/assets/images/feed2.jpg" alt="feed">-->
<!--                <img src="static/assets/images/feed3.jpg" alt="feed">-->
<!--                <img src="static/assets/images/feed4.jpg" alt="feed">-->
<!--                <img src="static/assets/images/feed5.jpg" alt="feed">-->
<!--                <img src="static/assets/images/feed6.jpg" alt="feed">-->
<!--                <img src="static/assets/images/feed7.jpg" alt="feed">-->
<!--                <img src="static/assets/images/feed8.jpg" alt="feed">-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="footer-copyright">-->
<!--      <div class="container">-->
<!--        <div class="row">-->
<!--          <div class="col-lg-8 col-md-6">-->
<!--                            <span>&lt;!&ndash; Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. &ndash;&gt;-->
<!--Copyright &copy;2019 All rights reserved | This template is made with <i class="fa fa-heart-o" aria-hidden="true"></i> by <a href="https://colorlib.com" target="_blank">Colorlib</a>-->
<!--                              &lt;!&ndash; Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. &ndash;&gt;-->
<!--</span>-->
<!--          </div>-->
<!--          <div class="col-lg-4 col-md-6">-->
<!--            <div class="social-icons">-->
<!--              <ul>-->
<!--                <li><a href="#"><i class="fa fa-facebook"></i></a></li>-->
<!--                <li><a href="#"><i class="fa fa-twitter"></i></a></li>-->
<!--                <li><a href="#"><i class="fa fa-dribbble"></i></a></li>-->
<!--                <li><a href="#"><i class="fa fa-behance"></i></a></li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </footer>-->
  <footer class="footer-area" style="padding: 20px 0;background: #444447;">
    <div class="footer-copyright" style="margin-top: 0px;text-align: center">
      <div class="container">
        <div style="text-align: center;font-size: 14px;">
          © 2024, mount gambier brewery pty ltd
        </div>
      </div>
    </div>
  </footer>
  <!-- Footer Area End -->

</div>
</template>
<script>
export default {
  name: 'app'
}
</script>

<style>
.custom-navbar {
  position: relative;
  top: 0;
  right: 0;
  background: $primary-color;
  padding: 7px 10px;
  @include border-radius(3px);
  @include transition(.2s);
  cursor: pointer;
  @include tablet() {
    display: block;
  }
  @include landscape-phone() {
    display: block;
  }
  @include portrait-phone() {
    display: block;
  }
  span {
    background: $light;
    display: block;
    width: 30px;
    margin: 6px 0;
    height: 2px;
  }
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 50px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
.fontfamily {
  font-family: "Old English Text MT", "Times New Roman", serif;
}
/* 文字滚动 */
.merquee {
  padding-top: 12px;
  padding-bottom: 12px;
  font-size: 16px;
  line-height: 1.3em;
  color: #FFFAEC;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  word-break: break-all;
  border-bottom: 5px solid red;
  border-top: 5px solid red;
  background-color: blue;
}
.merquee-txt {
  display: inline-block;
  /* 从右至左开始滚动 */
  animation: marqueeTransform 50s linear infinite;
}

@keyframes marqueeTransform {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(-100%, 0);
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?64d12a67